import React from 'react';
import Auth from './Auth';

// Kept for backward compatibility: /login still works,
// but renders the unified Auth page with the "Se connecter" tab.
export default function Login() {
  return <Auth defaultTab="login" />;
}
